import PhotoGallery from "./PhotoGallery";
import Title from "../UI/Title.tsx";
import Text from "../UI/Text.tsx";
import styles from "./PropertyShowCandidat.module.css";
import usePropertyPhotos from "../../hooks/use-property-photos";

function formatAddress(property) {
  const parts = [];
  if (property.rue) parts.push(property.rue);
  if (property.complement_adresse) parts.push(property.complement_adresse);
  if (property.cp || property.ville) {
    parts.push(`${property.cp || ""} ${property.ville || ""}`.trim());
  }
  return parts.join(", ");
}

function PropertyShowCandidat({ property }) {
  const { photos } = usePropertyPhotos(property?.id);
  if (!property) {
    return null;
  }
  return (
    <div className="content">
      <div className={styles.header}>
        <PhotoGallery photos={photos} propertyType={property.type} />
        <div>
          <Title variant="hecto" weight="bold">
            {property.nom}
          </Title>
          <Text className={styles.address}>{formatAddress(property)}</Text>
        </div>
      </div>
    </div>
  );
}

export default PropertyShowCandidat;
